import React from 'react'

import Image from 'next/image'

import { Column, Text } from 'Components/UI'

import {
  LogoFuturwiseImage,
  LogoMorpheusImage,
  LogoNetworkOSImage,
} from 'Assets/Image/CompanyLogos'
import {
  FuturwiseImage,
  MorpheusImage,
  NetworkOSImage,
} from 'Assets/Image/Products'

import {
  Card,
  CardContent,
  CardGrid,
  CardImage,
  CardLogo,
  SectionTitle,
  SectionWrapper,
} from './styles'

const PRODUCTS = [
  {
    id: 'futurwise',
    name: 'Futurwise',
    url: 'https://futurwise.com',
    description:
      'AI platform for saving, organizing, and summarizing research and media.',
    logo: LogoFuturwiseImage,
    image: FuturwiseImage,
    bleedImageRight: false,
    backgroundColor: '#F1F2F8',
  },
  {
    id: 'morpheus',
    name: 'Morpheus.Network',
    url: 'https://morpheus.network',
    description:
      'Enterprise supply-chain platform for workflow automation and visibility.',
    logo: LogoMorpheusImage,
    image: MorpheusImage,
    bleedImageRight: false,
    backgroundColor: '#F0F4F9',
  },
  {
    id: 'networkos',
    name: 'NetworkOS',
    url: 'https://collaboration.ai/products/networkos/',
    description:
      'Community intelligence platform for mapping networks and relationships.',
    logo: LogoNetworkOSImage,
    image: NetworkOSImage,
    bleedImageRight: true,
    backgroundColor: '#F6F4F4',
  },
] as const

// Cards cap at 520px with 32px padding (the bleed variant drops the right
// one). Measured: 1440px+ -> 388 CSS px, 1290 -> 338, 1024 -> 249, 768 -> 456
// (single column, wider card), 412 -> 316.
const CARD_IMAGE_SIZES =
  '(min-width: 1440px) 388px, (min-width: 992px) 27vw, (min-width: 560px) 60vw, 100vw'

function MeetStartupCraftSection() {
  return (
    <SectionWrapper>
      <Column mb={['80px', '80px', '70px', '70px', '64px', '64px']}>
        <SectionTitle as="h2">Meet StartupCraft</SectionTitle>

        <Text body mt={3} semiLight title40>
          StartupCraft builds the operational platforms businesses run on — and
          increasingly, the AI that runs inside them.
        </Text>

        <Text body body16 mt={7} semiLight>
          Since 2015. 120+ products, senior engineers only. Every engagement
          opens with a paid discovery.
        </Text>
      </Column>

      <CardGrid>
        {PRODUCTS.map(
          ({
            id,
            name,
            url,
            description,
            logo,
            image,
            backgroundColor,
            bleedImageRight,
          }) => (
            <Card
              background={backgroundColor}
              href={url}
              key={id}
              rel="noopener noreferrer"
              target="_blank"
            >
              <CardContent>
                <CardLogo>
                  <Image alt={name} src={logo} />
                </CardLogo>
                <Text as="h3" body16 medium mt={6}>
                  {name}
                </Text>

                <Text body body16 mt={4} semiLight>
                  {description}
                </Text>
              </CardContent>

              <CardImage bleedImageRight={bleedImageRight}>
                <Image
                  alt={`${name} product screenshot`}
                  sizes={CARD_IMAGE_SIZES}
                  src={image}
                />
              </CardImage>
            </Card>
          ),
        )}
      </CardGrid>
    </SectionWrapper>
  )
}

export default MeetStartupCraftSection
